/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExpectedArrival = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8 2h14v20H8zm6 18h2v-4h-2zm4 0h2V4H10v16h2v-6h6zM14 8h-2V6h2zm4 0h-2V6h2zM3.086 11.5 1.293 9.707l1.414-1.414L5.914 11.5l-3.207 3.207-1.414-1.414zM14 12h-2v-2h2zm4 0h-2v-2h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgExpectedArrival as ExpectedArrival };
